export { default } from './DetailPageSectionHeader';
